module.exports = __webpack_public_path__ + "img/CEFED-Panoramique-Reduced.15de523b.png";